// import {Poly} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/Poly';
// import {ErrorNotifierSopNode} from '../../polygonjs-editor/src/editor/core/error/ErrorNotifierNode';
// import {Poly} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/Poly';
import {AllRegister} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/poly/registers/All';
// import {AllModulesRegister} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/poly/registers/modules/All';
import {FilesRegister} from '../../polygonjs-editor/src/editor/self_contained/FilesRegister';
// import {WebEditorPolyNodeSaveController} from '../editor/WebEditorPolyNodeSaveController';

// THOSE SHOULD NOT BE ON THE ONLINE DEMO ANYWAY!
// NOT UNTIL I CAN EXPORT THEM WITH HTML
// AND...
// if I could export them, I would really need to make sure
// I only register a specific version of those, and not just
// my local version
// Although compile time is really really long with those
// import {polyPluginMapbox} from '../../../../../plugins/plugin-mapbox/src/index';
// import {polyPluginMarkerTracking} from '../../../../../plugins/plugin-marker-tracking/src/index';
// // import { Poly } from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/Poly';
// // import {polyPluginOcclusion} from '../../../../../plugins/occlusion/src/index';
// // import {polyPluginPhysics} from '../../../../../plugins/physics/src/index';
// // import {polyPluginTrace} from '../../../../../plugins/trace/src/index';
// // import {polyPluginMediapipeFacemesh} from '../../../../../plugins/mediapipe_facemesh/src/index';
// // import {preparePbr, PbrRegister} from '../../polygonjs-editor/src/engine/pbr';

// function registerPluginsForLocalTests() {
// 	// PbrRegister.run(Poly);
// 	// (window as any).preparePbr = preparePbr;
// 	// const integrations_element = document.getElementById('integrations-data');
// 	// if (!integrations_element) {
// 	// 	console.error('DEV: integration-data element not found');
// 	// }
// 	// const token = integrations_element?.dataset['mapboxToken'];
// 	// if (token) {
// 	// 	polyPluginMapbox.setToken(token);
// 	// }
// 	// const mapboxToken = 'pk.eyJ1IjoiZnJhZGluZyIsImEiOiJjandqNTVnMnYwM29qM3lxcDJrdGd0bndsIn0.O3sTf68l7PGA6y5FVPO-_g';
// 	// polyPluginMapbox.setToken(mapboxToken);
// 	// Poly.registerPlugin(polyPluginMapbox as any);
// 	Poly.registerPlugin(polyPluginMarkerTracking as any);
// 	// Poly.registerPlugin(polyPluginOcclusion as any); // this is fucking terrible
// 	// Poly.registerPlugin(polyPluginPhysics as any);
// 	// Poly.registerPlugin(polyPluginTrace as any);
// 	// Poly.registerPlugin(polyPluginMediapipeFacemesh as any);
// }

// if (process.env.NODE_ENV == 'development') {
// 	registerPluginsForLocalTests();
// }

export class EngineExtendedAllRegister {
	private static _started = false;
	static async run() {
		if (this._started) {
			return;
		}
		this._started = true;
		// AllModulesRegister.run(Poly);
		await FilesRegister.init();
		AllRegister.registerAll();
		// no need, as polyNodes are only supported in local app
		// also, importing this has a side effect of loading a bg color to the public scene page,
		// most likely as it imports the editor component
		// new WebEditorPolyNodeSaveController().readAndRegisterPolyNodes();

		// if (process.env.NODE_ENV != 'production') {
		// 	console.log('registerNode', ErrorNotifierSopNode);
		// 	Poly.registerNode(ErrorNotifierSopNode, 'debug');
		// }

		// register local expression
		// local expression should only be registered for the desktop app
		// if registered for the web version, it then imports DesktopController
		// which in turns imports the Editor.
		// Poly.instance().expressions_register.register_expression(
		// 	LocalExpression,
		// 	"local"
		// );
		// this._set_asset_expression_resolver();

		// register poly nodes from dom elements
		// load poly_nodes
	}
	// static _set_asset_expression_resolver() {
	// 	const asset_method_class = Poly.expressionsRegister.get_method(
	// 		"asset"
	// 	);
	// 	if (asset_method_class) {
	// 		asset_method_class.set_url_resolver(async (args) => {
	// 			const saved_scene_endpoint = `/api/scenes/${args.scene_uuid}/uploads/${args.asset_name}`;
	// 			const new_scene_endpoint = `/api/uploads/${args.asset_name}`;
	// 			const api_url = args.scene_uuid
	// 				? saved_scene_endpoint
	// 				: new_scene_endpoint;
	// 			const response = await fetch(api_url);
	// 			const json = await response.json();
	// 			return json.url;
	// 		});
	// 	} else {
	// 		console.log("no asset method found");
	// 	}
	// }
}
